import * as React from 'react';

import { cn } from './lib/cn';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // `text-lg` at EVERY breakpoint — kept in lockstep with `Input` so a
          // textarea and the fields beside it read at one size. As there, the
          // placeholder carries NO size rule of its own: it inherits, so the box
          // never changes size the moment the user types, and a call-site override
          // moves typed text and placeholder together.
          //
          // The old `text-2xl md:text-xl` pair is gone on purpose — under it an
          // unprefixed call-site `text-lg` lost above 768px (different
          // tailwind-merge groups), so overrides silently did nothing on desktop.
          'border-input bg-background placeholder:text-muted-foreground flex min-h-[80px] w-full rounded-md border px-3 py-2 text-lg focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-0 focus-visible:ring-ring/40 focus-visible:border-ring/60 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
